import axios from 'axios';
import { req } from './axiosFun';

export function getUserList(params) {
    return req("get", "/api/authorizedUser/list", params)
}

export function addUser(params) {
    return req('post', '/api/authorizedUser/add', params)
}

export function updateUser(params) {
    return req('post', '/api/authorizedUser/update', params)
}

export function deleteUser(params) {
    return req('delete', '/api/authorizedUser/delete', params)
}

export function bindDevice(params) {
    return req('post', '/api/authorizedUser/bindDevice', params)
}

export function unbindDevice(params) {
    return req('post', '/api/authorizedUser/unbindDevice', params)
}

export function getUserByDeviceId(params) {
    return req('get', '/api/authorizedUser/getUserByDeviceId', params)
}


// WEBPACK FOOTER //
// ./src/api/authorizedUser.js